var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadSpeaker = function SvgFadSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192 41.993C192 33.16 184.844 26 176 26H80c-8.836 0-16 7.166-16 15.993v174.014C64 224.84 71.156 232 80 232h96c8.836 0 16-7.166 16-15.993V41.993z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 51.008c0-4.423-3.588-8.008-8-8.008H88c-4.419 0-8 3.573-8 8.008v155.984c0 4.423 3.588 8.008 8 8.008h80c4.419 0 8-3.573 8-8.008V51.008z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 104c12.703 0 23-10.521 23-23.5S140.703 57 128 57s-23 10.521-23 23.5 10.297 23.5 23 23.5zm0 88c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 176c8.56 0 15.5-7.163 15.5-16s-6.94-16-15.5-16c-8.56 0-15.5 7.163-15.5 16s6.94 16 15.5 16zm-.5-86.769c4.694 0 8.953-.25 8.953-9.087s-4.225-9.48-8.92-9.48c-4.694 0-8.919.643-8.919 9.48s4.192 9.087 8.886 9.087z",
    fill: "#FFF"
  }))));
};
export { SvgFadSpeaker as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-speaker.0583e94f.svg";